import type { TrialInDatabaseForAlgolia } from '@modules/trials/types/TrialInDatabaseForAlgolia'

export default function getTreatmentTypeFromTrialInterventions(
  trial: Pick<TrialInDatabaseForAlgolia, 'treatments'>,
) {
  const primaryTreatments = trial.treatments?.filter((t) => t.isPrimary) ?? []

  const [primaryTreatment] = primaryTreatments

  const isValidClass = (t: string | null) => {
    if (!t) {
      return false
    }

    return (
      !['Other', 'Drug', 'Unknown'].includes(t ?? '') &&
      t !== primaryTreatment?.name
    )
  }

  const primaryTreatmentClass = isValidClass(primaryTreatment?.class ?? null)
    ? primaryTreatment?.class
    : undefined

  const primaryTreatmentDomain = isValidClass(primaryTreatment?.domain ?? null)
    ? primaryTreatment?.domain
    : undefined

  const primaryTreatmentType = primaryTreatmentClass ?? primaryTreatmentDomain

  return primaryTreatmentType
}
